// Utility function to build query string
export function buildQueryString(params) {
    const validEntries = Object.keys(params).filter(
      (key) => params[key] !== null && params[key] !== undefined && params[key] !== ""
    );
  
    if (validEntries.length === 0) {
      return ""; // Return empty string if all values are null or undefined
    }
  
    const queryString = validEntries
      .map((key) => {
        // Handle arrays (e.g. trip_date_filter[])
        if (Array.isArray(params[key])) {
          // For arrays, create multiple key=value pairs for each item in the array
          return params[key]
            .map((value) => `${encodeURIComponent(key)}[]=${encodeURIComponent(value)}`)
            .join("&");
        }
        // For non-array values, simply encode them
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join("&");
  
    return `?${queryString}`;
  }
  